// extracted by mini-css-extract-plugin
export default {"templateDescription":"EnvironmentCreate_templateDescription__eHZSM"};